import { ApiService } from '@/api';
import {
  TvGeeksForLeaderboard,
  TvLatestKudosPhotos,
  TvOpportunity,
  TvRecentActivity,
} from '@/models/kitchen-tv';

export class KitchenTvApi {
  private readonly baseUrlOld = '/api/Tv';
  private readonly baseUrl = '/api/tv';

  public async fetchRecentActivities(limit: number, date: string, spanInDays: number): Promise<TvRecentActivity[]> {
    const params = { recentActivitiesNumber: limit, referenceDate: date, spanInDays };
    const response = await ApiService.get(`${this.baseUrl}/recent-activities`, { params });
    return response.json();
  }

  public async fetchGeeksForTvLeaderboard(limit: number, date: string): Promise<TvGeeksForLeaderboard> {
    const params = { topGeeksNumber: limit, leveledUpEvaluationStartDatetime: date };
    const response = await ApiService.get(`${this.baseUrlOld}/GetGeeksForTvLeaderboard`, { params });
    return response.json();
  }

  public async fetchLatestKudosPhotos(): Promise<TvLatestKudosPhotos> {
    const response = await ApiService.get(`${this.baseUrlOld}/GetLatestKudosPhotos`);
    return response.json();
  }

  public async fetchOpportunities(): Promise<TvOpportunity> {
    const response = await ApiService.get(`${this.baseUrl}/opportunities`);
    return response.json();
  }
}
